import { render } from "./RbMidScreenDialog.vue?vue&type=template&id=6e794220&scoped=true"
import script from "./RbMidScreenDialog.vue?vue&type=script&lang=js"
export * from "./RbMidScreenDialog.vue?vue&type=script&lang=js"

import "./RbMidScreenDialog.vue?vue&type=style&index=0&id=6e794220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e794220"]])

export default __exports__